'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Set = require('./containers/Set');

var _Set2 = _interopRequireDefault(_Set);

var _FilterPreviewer = require('./components/FilterPreviewer');

var _FilterPreviewer2 = _interopRequireDefault(_FilterPreviewer);

var _genericUtils = require('./utils/genericUtils');

var _sqlUtils = require('./utils/sqlUtils');

var _expression = require('./defaults/expression');

var _expression2 = _interopRequireDefault(_expression);

var _CalciteThemeProvider = require('calcite-react/CalciteThemeProvider');

var _CalciteThemeProvider2 = _interopRequireDefault(_CalciteThemeProvider);

var _Panel = require('calcite-react/Panel');

var _Panel2 = _interopRequireDefault(_Panel);

var _Button = require('calcite-react/Button');

var _Button2 = _interopRequireDefault(_Button);

var _Form = require('calcite-react/Form');

var _Tooltip = require('calcite-react/Tooltip');

var _Tooltip2 = _interopRequireDefault(_Tooltip);

var _PlusIcon = require('./icons/PlusIcon');

var _PlusIcon2 = _interopRequireDefault(_PlusIcon);

var _lodash = require('lodash');

var _SetStyled = require('./containers/Set-styled');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ArcgisFilter = function (_Component) {
  _inherits(ArcgisFilter, _Component);

  function ArcgisFilter(props) {
    _classCallCheck(this, ArcgisFilter);

    var _this = _possibleConstructorReturn(this, (ArcgisFilter.__proto__ || Object.getPrototypeOf(ArcgisFilter)).call(this, props));

    _this.componentDidUpdate = function (prevProps, prevState) {
      // check if rehydrating from filterState
      if (JSON.stringify(prevProps.filterState) !== JSON.stringify(_this.props.filterState)) {
        _this.setState(_extends({}, _this.props.filterState), function () {
          _this.onChange(_this.state);
        });
      }
    };

    _this.onChange = function (state) {
      var filter = (0, _sqlUtils.buildFilter)(state);
      _this.props.onChange(filter, state);
    };

    _this.updateSets = function (sets) {
      _this.setState({ sets: sets }, function () {
        _this.onChange(_this.state);
      });
    };

    _this.handleAddSet = function () {
      var sets = _this.state.sets;

      sets[(0, _genericUtils.generateId)()] = {
        mustMatchAll: true,
        expressions: _defineProperty({}, (0, _genericUtils.generateId)(), _expression2.default)
      };
      _this.updateSets(sets);
    };

    _this.handleRemoveSet = function (setId) {
      var sets = _this.state.sets;

      delete sets[setId];
      _this.updateSets(sets);
    };

    _this.handleUpdateSetOperator = function (setId, setOperator) {
      var sets = _this.state.sets;

      sets[setId].mustMatchAll = setOperator;
      _this.updateSets(sets);
    };

    _this.handleAddExpression = function (setId) {
      var sets = _this.state.sets;

      sets[setId].expressions[(0, _genericUtils.generateId)()] = _expression2.default;
      _this.updateSets(sets);
    };

    _this.handleRemoveExpression = function (setId, expressionId) {
      var sets = _this.state.sets;

      delete sets[setId].expressions[expressionId];
      _this.updateSets(sets);
    };

    _this.handleUpdateExpression = function (setId, expression) {
      var sets = _this.state.sets;

      var currentExpression = sets[setId].expressions[expression.id];
      sets[setId].expressions[expression.id] = _extends({}, currentExpression, expression);
      _this.updateSets(sets);
    };

    _this.handleUpdateFilterOperator = function (mustMatchAll) {
      _this.setState({ mustMatchAll: mustMatchAll }, function () {
        _this.onChange(_this.state);
      });
    };

    _this.getSets = function (sets) {
      return Object.keys(sets).map(function (key) {
        var set = sets[key];
        return _react2.default.createElement(_Set2.default, {
          key: key,
          id: key,
          fields: _this.props.fields,
          mustMatchAll: set.mustMatchAll,
          expressions: set.expressions,
          disableUnique: _this.props.disableUnique,
          updateExpression: _this.handleUpdateExpression,
          onFieldChange: _this.handleFieldChanged,
          onOperatorChange: _this.handleOperatorChanged,
          onValueChange: _this.handleValueChanged,
          updateSetOperator: _this.handleUpdateSetOperator,
          removeSet: _this.handleRemoveSet,
          addExpression: _this.handleAddExpression,
          removeExpression: _this.handleRemoveExpression
        });
      });
    };

    _this.state = {
      mustMatchAll: true,
      sets: _defineProperty({}, (0, _genericUtils.generateId)(), {
        mustMatchAll: true,
        expressions: _defineProperty({}, (0, _genericUtils.generateId)(), _expression2.default)
      })
    };
    return _this;
  }

  _createClass(ArcgisFilter, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      if (this.props && this.props.filterState && !(0, _lodash.isEqual)(this.props.filterState, this.state)) this.setState(_extends({}, this.props.filterState), function () {
        _this2.onChange(_this2.state);
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      if (!this.props.fields) {
        return null;
      }

      return _react2.default.createElement(
        _CalciteThemeProvider2.default,
        null,
        _react2.default.createElement(
          _Panel2.default,
          { white: true },
          _react2.default.createElement(
            _SetStyled.StyledSetHeaderRow,
            null,
            _react2.default.createElement(
              _Form.FormControl,
              { horizontal: true, style: { marginBottom: '5px' } },
              _react2.default.createElement(
                _Form.FormControlLabel,
                { style: { marginRight: '10px' } },
                'Filter Operator:'
              ),
              _react2.default.createElement(
                _Button.ButtonGroup,
                null,
                _react2.default.createElement(
                  _Tooltip2.default,
                  { title: 'All Expressions Match', enterDelay: 400 },
                  _react2.default.createElement(
                    _Button2.default,
                    {
                      extraSmall: true,
                      clear: !this.state.mustMatchAll,
                      onClick: function onClick() {
                        return _this3.handleUpdateFilterOperator(true);
                      }
                    },
                    'AND'
                  )
                ),
                _react2.default.createElement(
                  _Tooltip2.default,
                  { title: 'Any Expressions Match', enterDelay: 400 },
                  _react2.default.createElement(
                    _Button2.default,
                    {
                      extraSmall: true,
                      clear: this.state.mustMatchAll,
                      onClick: function onClick() {
                        return _this3.handleUpdateFilterOperator(false);
                      }
                    },
                    'OR'
                  )
                )
              )
            )
          ),
          this.getSets(this.state.sets),
          _react2.default.createElement(
            _SetStyled.StyledAddSetButton,
            { onClick: this.handleAddSet },
            _react2.default.createElement(_PlusIcon2.default, { fill: _CalciteThemeProvider.CalciteTheme.palette.gray }),
            ' Add Set'
          ),
          _react2.default.createElement(_FilterPreviewer2.default, {
            options: {
              mustMatchAll: this.state.mustMatchAll,
              sets: this.state.sets
            }
          })
        )
      );
    }
  }]);

  return ArcgisFilter;
}(_react.Component);

ArcgisFilter.propTypes = {
  /** ArcGIS REST API or JSAPI fields definition object. */
  fields: _propTypes2.default.object.isRequired,
  /** Object used to persist/rehydrate the filter */
  filterState: _propTypes2.default.object,
  /** Fired when the filter changes. Receives the filter string as an argument  */
  onChange: _propTypes2.default.func,
  /** Disables the option to pick from unique values. */
  disableUnique: _propTypes2.default.bool
};

ArcgisFilter.defaultProps = {
  disableUnique: false
};

exports.default = ArcgisFilter;


//////////////////
// WEBPACK FOOTER
// ./node_modules/arcgis-filter/dist/ArcgisFilter.js
// module id = 1469
// module chunks = 0